import { useState, useEffect } from "react";

const pad = (n) => String(n).padStart(2, "0");

const getTimeLeft = (targetMs) => {
  const diff = targetMs - Date.now();
  if (diff <= 0) return null;           // moment passed
  return {
    days:    Math.floor(diff / 86_400_000),
    hours:   Math.floor(diff / 3_600_000) % 24,
    minutes: Math.floor(diff / 60_000)   % 60,
    seconds: Math.floor(diff / 1000)     % 60,
  };
};

export default function Countdown({ startIso, endIso }) {
  const startMs = new Date(startIso).getTime();
  const endMs = endIso ? new Date(endIso).getTime() : null;
  const [left, setLeft] = useState(() => getTimeLeft(startMs));

  useEffect(() => {
    const id = setInterval(() => setLeft(getTimeLeft(startMs)), 1000);
    return () => clearInterval(id);      // cleanup
  }, [startMs]);

  // Auction has ended.
  if (endMs && Date.now() >= endMs) {
    return <span className="auction-status auction-status--ended">Concluida</span>;
  }

  // Start time passed but not ended → live.
  if (!left) {
    return (
      <span className="auction-status auction-status--live">
        <span className="auction-status__dot" />
        En vivo
      </span>
    );
  }

  // Upcoming → compact countdown (skip zero leading units; always show seconds).
  const parts = [];
  if (left.days)    parts.push(`${left.days}d`);
  if (left.hours)   parts.push(`${pad(left.hours)}h`);
  if (left.minutes) parts.push(`${pad(left.minutes)}m`);
  parts.push(`${pad(left.seconds)}s`);

  return (
    <span className="auction-status auction-status--soon">
      <span className="auction-status__label">Inicia en</span>
      <span className="auction-status__time">{parts.join(" ")}</span>
    </span>
  );
}
